import { render, staticRenderFns } from "./visit-cusname-select.vue?vue&type=template&id=5b28beb8&"
import script from "./visit-cusname-select.vue?vue&type=script&lang=js&"
export * from "./visit-cusname-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports